import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';

import footerStyles from './footer.module.scss';

const Footer = () => (
  <footer className={`footer ${footerStyles.footer}`}>
     <h6>Copyright © Beth 2019</h6>
  </footer>
);

Footer.propTypes = {

};
Footer.defaultProps = {

};

export default Footer;
